import firebase from 'firebase';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyA3AjCbnYZWOne7s05AeMetXwnbooYodI8",
    authDomain: "accord-chat.firebaseapp.com",
    databaseURL: "https://accord-chat.firebaseio.com",
    projectId: "accord-chat",
    storageBucket: "accord-chat.appspot.com",
    messagingSenderId: "415730732830",
    appId: "1:415730732830:web:76f428ab08b5eeb1d0030f",
    measurementId: "G-XY539FDD7F"
};


const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;